import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from '../SmartEvacLogo.jpg';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import axios from 'axios';
import React, { useState, useEffect,Component  } from "react";
import { useNavigate } from 'react-router-dom';
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";

const AWS = require('aws-sdk');


const client = new S3Client({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

AWS.config.update({
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
});


const params = {
  TableName: "Main_table"
};


function AdminPage() {
  const [fname, setfname] = useState("");
  const [sname, setsname] = useState("");
  const [fetched_data, setData] = useState([]);
  const [filtered_data, setFiltered] = useState([]);
  const [not_detected, setnotDetected] = useState('');
  const [imageUrls, setImageUrls] = useState({});

  const navigate = useNavigate();
  const HandleHome = (event) => {
    event.preventDefault();
    navigate('/adminpage'); 
  };
  const SearchPerson = (event) => {
    event.preventDefault();
    navigate('/searchPerson'); 
  };
  const HandleAddPerson = (event) => {
    event.preventDefault();
    navigate('/addPersonOption'); 
  };
  const StartEvac = (event) => {
    event.preventDefault();
    navigate('/start'); 
  };
  const RemovePerson = (event) => {
    event.preventDefault();
    navigate('/removePersonOption'); 
  };
  const ModifyPerson = (event) => {
    event.preventDefault();
    navigate('/modify'); 
  };
  const emergencyPlan = (event) => {
    event.preventDefault();
    navigate('/emergencyPlan'); 
  };


  const fetchData = async (event) => {
    event.preventDefault();
    setnotDetected('');
    const dynamoDB = new AWS.DynamoDB.DocumentClient();
    dynamoDB.scan(params, (err, result) => {
      if (err) {
        console.error('Error scanning the table',err);
      } else {
        try{
          console.log('Scan succeeded:', JSON.stringify(result, null, 2));
          const filtered = result.Items.filter(searchPerson);
          console.log(filtered);
          setData(filtered)
          getImage(filtered[0].UserID);
        }catch{
          setnotDetected(fname+" "+sname+" could not be found");
        }
      }
    });
  };

  const getImage = async (UserID) => {
    const getObjectParams = {
      Bucket: "facecard-bucket", 
      Key: `${UserID}.jpg`,
    };
    const command = new GetObjectCommand(getObjectParams);
    try {
      const url = await getSignedUrl(client, command, { expiresIn: 3600 });
      setImageUrls(url);
      console.log(imageUrls);
    } catch (error) {
      console.error("Error fetching image", error);
    }
  }


  function searchPerson(item) {
    return item.fname === fname || item.sname === sname;
  }


  return (
    <Container className= "main-page-content">
      <Row>
        <Col>
          <img className="app-logo" src={Logo} width="400" height="50" alt="SmartEvac Logo" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col>
          <h3>Search Person</h3>
          <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                  <Nav.Link href="#home" onClick={HandleHome}>Home</Nav.Link>
                  <Nav.Link href="#link"onClick={SearchPerson} >Search</Nav.Link>
                  <Nav.Link href="#link" onClick={HandleAddPerson}>Add</Nav.Link>
                  <Nav.Link href="#link" onClick={RemovePerson}>Remove</Nav.Link>
                  <Nav.Link href="#link" onClick={ModifyPerson}>Modify</Nav.Link>
                  <Nav.Link href="#link" onClick={emergencyPlan}>Plan</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                  <Nav.Link href="#link" onClick={StartEvac}>Start Evacuation</Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Col>
      </Row>
      <br></br>
      <Row className="justify-content-center">
        <Col xs={7} sm={7} md={7} lg={7}>
          <form className="loginForm" onSubmit={fetchData}>
            <p className="Title">Search Person</p>
            <Row>
              <Col xs={12} md={6}>
                <div className="form-group">
                  <input type="text" name="fname" placeholder="Forename" onChange={(e) => setfname(e.target.value)} />
                </div>
                <div className="form-group">
                  <input type="text" name="sname" placeholder="Surname" onChange={(e) => setsname(e.target.value)} />
                </div>
              </Col>
              <h2>{not_detected}</h2>
              <button type="submit" className="login-button">Search</button>
            </Row>
            <br></br>
            <br></br>
            <h3>Personal Information</h3>
            <Row>
              <table className="table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>age</th>
                    <th>sex</th>
                    <th>height</th>
                    <th>ethnicity</th>
                  </tr>
                </thead>
                <tbody>
                  {fetched_data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.UserID}</td>
                      <td>{item.fname}</td>
                      <td>{item.sname}</td>
                      <td>{item.age}</td>
                      <td>{item.sex}</td>
                      <td>{item.height}</td>
                      <td>{item.ethnicity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <br></br>
            <br></br>
            <h3>Address/ Contact Details</h3>
            <Row>
              <table className="table">
                <thead>
                  <tr>
                    <th>City</th>
                    <th>House</th>
                    <th>Postcode</th>
                    <th>Street</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {fetched_data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.city}</td>
                      <td>{item.house_num}</td>
                      <td>{item.post}</td>
                      <td>{item.street}</td>
                      <td>{item.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <br></br>
            <br></br>
            <h3>Emergency Contact details</h3>
            <Row>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Number</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {fetched_data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.emergencyName}</td>
                      <td>{item.emergencyNumber}</td>
                      <td>{item.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
            <br></br>
            <br></br>
            <h3>Facecard</h3>
            <Row>
              <table className="table">
                <tbody>
                  {fetched_data.map((item, index) => (
                    <tr key={index}>
                      <td>
                          <img src={imageUrls} width="400" height="400" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Row>
          </form>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminPage;
